/* eslint-disable no-magic-numbers */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Link from 'Component/Link';
import StoreLocatorIcon from 'Component/StoreLocatorIcon';

import './StoreLocatorLink.style';

/** @namespace PeggysagePwa/Component/StoreLocatorLink/Component/getStoreLocatorUrl */
export function getStoreLocatorUrl(storeCode) {
    if (!storeCode) {
        return 'https://boutique.peggysage.com/';
    }

    const langCode = storeCode.substr(0, 2).toLowerCase();
    const countryCode = storeCode.substr(3, 2).toLowerCase();

    // eslint-disable-next-line
    let url = '';

    switch (langCode) {
    case 'en':
    case 'es':
        url = 'https://shop.peggysage.com/';
        break;
    case 'de':
        url = 'https://geschafte.peggysage.com/';
        break;
    default:
        url = 'https://boutique.peggysage.com/';
    }

    if (countryCode !== 'fr') {
        url += `?country=${countryCode}`;
    }

    return url;
}

/** @namespace PeggysagePwa/Component/StoreLocatorLink/Component */
export class StoreLocatorLinkComponent extends PureComponent {
    static propTypes = {
        hasLabel: PropTypes.bool,
        storeCode: PropTypes.string.isRequired
    };

    static defaultProps = {
        hasLabel: true
    };

    renderLabel() {
        const { hasLabel } = this.props;

        if (!hasLabel) {
            return null;
        }

        return (
            <span>{ __('Boutiques') }</span>
        );
    }

    render() {
        const { storeCode } = this.props;

        return (
            <Link
              to={ getStoreLocatorUrl(storeCode) }
              aria-label={ __('Boutiques') }
              block="StoreLocatorLink"
              isOpenInNewTab
            >
                <StoreLocatorIcon />
                { this.renderLabel() }
            </Link>
        );
    }
}

export default StoreLocatorLinkComponent;
